// extracted by mini-css-extract-plugin
export var boldText = "_77-4";
export var checkboxContainer = "_77-6";
export var closeIcon = "_77-i";
export var container = "_77-0";
export var drawer = "_77-8";
export var drawerContent = "_77-9";
export var extraSmallText = "_77-5";
export var fulfillmentGroupTable = "_77-e";
export var largeText = "_77-3";
export var loadingSpinnerContainer = "_77-j";
export var mediumText = "_77-2";
export var narrow = "_77-f";
export var notificationLink = "_77-l";
export var packageCheckIconContainer = "_77-7";
export var slideoutHeaderActions = "_77-g";
export var slideoutHeaderActionsShifted = "_77-h";
export var slideoutHeaderContainer = "_77-a";
export var slideoutModal = "_77-c";
export var stickyHeaderWrapper = "_77-b";
export var table = "_77-k";
export var tableContainer = "_77-d";
export var tertiaryText = "_77-1";